import {
  ButtonBase,
  Container,
  delayedCall,
  dispatcher,
  // IEvent,
  ingenuity,
  IObject,
  // IObject,
  ITween,
  killDelayedCall,
  SpineBase,
} from "@quest/base-core";
import { GrandOutroView } from "./GrandOutroView";
import {
  ButtonBaseBehavior,
  MeterBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther";
import { Emitter } from "@quest/pixi-bridge/dist/Particles/Emitter";
import { Linear } from "@quest/pixi-bridge/dist/easing/Easing";

import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { EventConstants } from "@quest/platform-murka-phase_2";

export class GrandOutroController {
  private readonly view: GrandOutroView;
  private grandOutroMainContainer: Container;
  private frontEmitter: Emitter;
  private backEmitter: Emitter;
  private grandBgSpine: SpineBase;
  private grandBgPortraitSpine: SpineBase;
  private grandfgSpine: SpineBase;
  private grandEffectSpine: SpineBase;

  private continueButton: ButtonBaseBehavior;

  private grandContinueButtonContainer: Container;

  constructor(view: GrandOutroView) {
    this.view = view;
    this.initializeElements();
    this.subscribeEvent();
  }

  /**
   * method initializeElements: initialize elements to class components.
   */
  private initializeElements(): void {
    this.grandOutroMainContainer = this.view.getContainerByID("grandOutroMainContainer");
    this.continueButton = this.view.getButtonById("continueButton") as ButtonBaseBehavior;

    this.continueButton.on(ButtonBase.UP, this.onContinuePressUp, this);
    this.grandContinueButtonContainer = this.view.getContainerByID("grandContinueButtonContainer");
  }

  /**
   * Subscribe events
   */
  private subscribeEvent(): void {
    this.unSubscribeEvent();
    dispatcher.on(eventDispatchers.SHOW_GRAND_BANNER, this.onShowOutroBanner, this);
  }
  /**
   * Unsubscribe events
  */
  private unSubscribeEvent(): void {
    dispatcher.off(eventDispatchers.SHOW_GRAND_BANNER, this.onShowOutroBanner, this);
  }

  /**
   * start outro spine
   */
  private onShowOutroBanner(): void {
    dispatcher.fireEvent(eventDispatchers.SHOW_POP_UP_BLUR_BG, gameConstants.SHOW_GRAND_BLUR_BG);
    this.playSound();
    this.grandOutroMainContainer.visible = true;
    // dispatcher.fireEvent(eventDispatchers.DISABLE_BOARD_BUTTONS);
    this.continueButton.disableAndTint();
    this.initializeSpine();
    this.playJpBannerAnim();
  }

  private playSound() {
    const soundObj: IObject = { id: SoundConstantGame.GRNAD_YOU_WON, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
    dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
  }

  /**
   * play jp outro spiine anim and coin shower
   */
  private playJpBannerAnim(): void {
    this.grandBgSpine.setPause(false);
    this.grandfgSpine.setPause(false);

    this.grandBgSpine.visible = true;
    if (!ingenuity.deviceEnv.isDesktop) {
      this.grandBgPortraitSpine.setPause(false);
      this.grandBgPortraitSpine.visible = true;
      this.grandBgPortraitSpine.playAnim("grand_clue_reward_outro_in_bg_portrait", false);
    }
    this.grandBgSpine.playAnim(`grand_clue_reward_outro_in_bg_desktop`, false);
    this.grandEffectSpine.playAnim(`grand_clue_reward_outro_in_effect`, false);
    delayedCall("CharacterSpinePlayDelay", SlotConstantsBehavior.DURATION_1000, () => {
      killDelayedCall("CharacterSpinePlayDelay");

      this.grandfgSpine.mask = this.view.getShapeById("JPMask");

      this.startGrandOutroTickup((ingenuity.parserModel as GameParserModel).getIsGrandJPPrize());
    });
    this.grandfgSpine.visible = true;
    this.grandfgSpine.playAnim(`grand_clue_reward_outro_in_fg_desktop`, false);
    delayedCall("coinExplodeDelay", SlotConstantsBehavior.DURATION_400, () => {
      this.startExplodeCoinAnim()

    })
    this.grandfgSpine.onComplete.addOnce(() => {
      this.grandContinueButtonContainer.visible = true;

      this.grandfgSpine.playAnim(`grand_clue_reward_outro_loop_fg_desktop`, true);
      this.grandBgSpine.playAnim(`grand_clue_reward_outro_loop_bg_desktop`, true);
      this.grandBgPortraitSpine?.playAnim("grand_clue_reward_outro_loop_bg_portrait", true);
      this.playRearCoinShower();
    });
  }

  /**
   * initialize spines
   */
  private initializeSpine(): void {
    this.grandBgSpine = this.view.getSpineById("grand_outro_bg");
    this.grandfgSpine = this.view.getSpineById("grand_outro");
    this.grandEffectSpine = this.view.getSpineById("grand_outro_effect");
    if (!ingenuity.deviceEnv.isDesktop) {
      this.grandBgPortraitSpine = this.view.getSpineById("grand_outro_bg_port");
    }
  }

  // Add to play coin shower
  private playRearCoinShower(): void {
    this.initializeCoinShowerEmitter();
    this.startCoinShowerEmitter();
  }

  /**
   * Initialize Data for Coin Shower Emmiter
   */
  private initializeCoinShowerEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 0.8,
        end: 1.2,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 500,
        end: 500,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 200,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 0,
      },
      lifetime: {
        min: 3,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.01,
      emitterLifetime: -1,
      maxParticles: 1500,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("grandRearCoinBlastContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
  }

  /**
   * function to initiate coin shower
   */
  private startCoinShowerEmitter(): void {
    this.backEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
    this.backEmitter.autoUpdate = true;
    this.backEmitter.emit = true;
  }

  /**
   * This method starts the coin shower animation
   */
  private startExplodeCoinAnim(): void {
    this.initializeCoinExplodeEmitter();
    this.startCoinExplodeEmitter();
  }

  /**
   * Initialize Data for Coin Explode Emmiter
   */
  private initializeCoinExplodeEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinfrontEmitter",
      autoStart: false,
      animConfig: [
        {
          framerate: 30,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 1,
        end: 1.47,
        minimumScaleMultiplier: 1,
      },
      speed: {
        start: 300,
        end: 500,
        minimumSpeedMultiplier: 4,
      },
      acceleration: {
        x: 0,
        y: 750,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: false,
      rotationSpeed: {
        min: 0,
        max: 10,
      },
      lifetime: {
        min: 5,
        max: 5,
      },
      blendMode: "normal",
      frequency: 0.001,
      emitterLifetime: 1,
      maxParticles: 100,
      pos: {
        x: 0,
        y: 50,
      },
      addAtBack: true,
      spawnType: "burst",
      particlesPerWave: 10,
      particleSpacing: 0,
      angleStart: 0,
    };
    const coinShowerContainer1: Container = this.view.getContainerByID("grandfrontCoinBlastContainer");
    ingenuity.currentGame.add.emitter(coinShowerContainer1, particleData, config) as Emitter;
  }

  /**
   * This method start the second emitter
   * @returns
   */
  private startCoinExplodeEmitter(): void {
    this.frontEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinfrontEmitter");
    this.frontEmitter.autoUpdate = true;
    this.frontEmitter.emit = true;
  }

  /**
   * function to start outro tickup
   */
  private startGrandOutroTickup(amount: number): void {
    const grandWinMeter = this.view.getMeterById("OutroWinAmount") as MeterBehavior;
    grandWinMeter.setValue(0)
    grandWinMeter.visible = true;
    this.view.getContainerByID("taptoclickMessage").alpha = 0.7;
    this.view.getContainerByID("taptoclickMessage").visible = true;
    this.continueButton.disableAndTint();
    grandWinMeter.startTick(amount, true, false, 1.5, true, () => {
      this.continueButton.enableAndTint();
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
    });
  }

  /**to handle continue pressup action */
  private onContinuePressUp(): void {
    this.continueButton.disableAndTint();
    this.hidePlayerMessage();
    if (this.backEmitter) {
      this.backEmitter.destroy();
      this.backEmitter.emit = false;
    }

    dispatcher.fireEvent(eventDispatchers.HIDE_INVESTINGATION_ROOM);
    this.grandOutroPresentationComplete();
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    // dispatcher.fireEvent(EventConstants.UPDATE_BS_WIN, { value: (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getclueRevealedInfo().creditsWon});
    if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
      dispatcher.fireEvent(EventConstants.UPDATE_BS_WIN, { value: (ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getclueRevealedInfo().creditsWon });
    } else {
      (ingenuity.parserModel as GameParserModel).setTotalFgCascadeWin((ingenuity.parserModel as GameParserModel).getTotalFgCascadeWin() + (ingenuity.parserModel as GameParserModel).getclueRevealedInfo().creditsWon);
      dispatcher.fireEvent(SlotEventConstantsBehavior.CONSOLE_TOTAL_WIN_METER, (
        (ingenuity.parserModel as GameParserModel).getCurrentlyProcessingFSAmt() +
        (ingenuity.parserModel as GameParserModel).getTotalFgCascadeWin()
      ));
      // dispatcher.fireEvent(SlotEventConstantsBehavior.CONSOLE_TOTAL_WIN_METER,  ((ingenuity.parserModel as GameParserModel).getTotalCascadeWin() + (ingenuity.parserModel as GameParserModel).getclueRevealedInfo().creditsWon));
      this.view.getMeterById(`OutroWinAmount`).visible = false;
    }
  }
  /**
   * function will hide player msg
   */
  private hidePlayerMessage(): void {
    const alphaTween: ITween = ingenuity.currentGame.add
      .tween(this.view.getContainerByID("taptoclickMessage"))
      .to({ alpha: 0 }, 300, Linear.None, true, 0, 0, false);
    alphaTween.onComplete.addOnce(() => {
      // dispatcher.fireEvent(eventDispatchers.SHOW_TOP_LOGO_ON_BANNER);
      dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
      this.view.getContainerByID("taptoclickMessage").visible = false;
      this.view.getContainerByID("taptoclickMessage").alpha = 1;
      alphaTween.stop();
      ingenuity.currentGame.tweens.remove(alphaTween);
    }, this);
  }

  /**
   * play grand outro spine
   */
  private grandOutroPresentationComplete(): void {
    const animateGrandBg = new Promise<void>((resolve) => {
      this.grandBgSpine.playAnim(`grand_clue_reward_outro_out_bg_desktop`, false);
      this.grandBgPortraitSpine?.playAnim("grand_clue_reward_outro_out_bg_portrait", false)
      this.grandBgSpine.onComplete.addOnce(() => {
        this.grandBgSpine.visible = false;
        if (!ingenuity.deviceEnv.isDesktop) {
          this.grandBgPortraitSpine.visible = false;
        }
        resolve();
        const resetMeterData: any = { symbol51: [], symbol52: [], symbol53: [] };
        (ingenuity.parserModel as GameParserModel).setclueInfo(resetMeterData);
        dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        // dispatcher.fireEvent(eventDispatchers.SHOW_NEXT_FEATURE_PRESENTATION);

      });
    });
    const animateGrandFg = new Promise<void>((resolve) => {
      this.grandfgSpine.playAnim(`grand_clue_reward_outro_out_fg_desktop`, false);
      this.grandfgSpine.onComplete.addOnce(() => {
        this.grandfgSpine.visible = false;
        resolve();
      });
    });
    Promise.all([animateGrandBg, animateGrandFg])
      .then(() => {
        this.resetFeature();
      })
      .catch((error) => {
        console.error("Error with animations:", error);
      });
  }

  /**
   * reset function
   */
  private resetFeature(): void {
    // dispatcher.fireEvent(SlotEventConstantsBehavior.STOP_GAME_SOUND, { id: SoundConstantGame.GRNAD_YOU_WON, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD });
    dispatcher.fireEvent(eventDispatchers.RESET_ROOM_AFTER_GRAND);
    this.grandfgSpine.mask = null
    this.view.getMeterById(`OutroWinAmount`).setValue(0);
    this.grandOutroMainContainer.visible = false;

    this.frontEmitter.destroy();
    this.frontEmitter.emit = false;

    this.grandBgSpine.setPause(true);
    this.grandfgSpine.setPause(true);

    this.grandBgSpine = null;
    this.grandBgPortraitSpine = null;
    this.grandfgSpine = null;

    this.view.getContainerByID("grandRearCoinBlastContainer").removeChildren();
    this.view.getContainerByID("grandfrontCoinBlastContainer").removeChildren();

    // !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.TOP_LOGO_SHOW_ON_BIG_WIN);
  }
}
